import { api } from '../lib/api';

export interface PlatformBrandingSettings {
  hasLogo: boolean;
  updatedAt: string;
}

export async function getPlatformBranding(): Promise<PlatformBrandingSettings> {
  const { data } = await api.get<PlatformBrandingSettings>('/platform-branding');
  return data;
}

export async function uploadPlatformLogo(file: File): Promise<PlatformBrandingSettings> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await api.post<PlatformBrandingSettings>('/platform-branding/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

// Public endpoint (backend marks it @Public()) - it needs to render on the
// login page before any token exists, so unlike a customer's co-branding
// logo it's used directly in <img src> rather than fetched as an
// authenticated blob.
export const PLATFORM_LOGO_URL = '/api/platform-branding/logo';

// §116: invoice template designer.
export interface InvoiceTemplate {
  hasLogo: boolean;
  companyName: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  postcode: string | null;
  country: string | null;
  vatNumber: string | null;
  registrationNumber: string | null;
  bankDetails: string | null;
  footerNote: string | null;
  accentColor: string | null;
  updatedAt: string;
}

export async function getInvoiceTemplate(): Promise<InvoiceTemplate> {
  const { data } = await api.get<InvoiceTemplate>('/platform-branding/invoice-template');
  return data;
}

export type UpdateInvoiceTemplateInput = Partial<
  Omit<InvoiceTemplate, 'hasLogo' | 'updatedAt'>
>;

export async function updateInvoiceTemplate(input: UpdateInvoiceTemplateInput): Promise<InvoiceTemplate> {
  const { data } = await api.patch<InvoiceTemplate>('/platform-branding/invoice-template', input);
  return data;
}
